module.exports = __webpack_public_path__ + "img/Remove.c5da7440.svg";